function StickyHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-ion-background-color sticky top-0 z-10">{children}</div>
  )
}

export { StickyHeader }
